<!--<app-carga *ngIf="showElement"></app-carga>-->

<app-header *ngIf="!showElement"></app-header>

<router-outlet *ngIf="!showElement"></router-outlet>

<app-footer *ngIf="!showElement"></app-footer>